import ProductCard from "./ProductCard.component";
import { EMERALD_CITY_PRODUCTS } from "@misc/Links";

const DATA = [
 
  {
    title: "Bank",
    desc: "Bank serves as a reserve for CROWNs where one could deposit CROWNS and receive XCROWNS. The bank will receive a certain portion of fees for every activity in The Emerald City ecosystem which the stakers will be able to earn. Thus ensuring that the XCROWN will always be more than CROWN. The deposits and the fees can be withdrawn instantly making the bank a lucrative part of the Emerald City ecosystem.",
    link: EMERALD_CITY_PRODUCTS.BANK,
  },
  {
    title: "Land certificates",
    desc: "Land certificates are the proof of land in Emerald City. These specify the type of land that can be bought with the certificate.  1/3rd of the Emerald city can be bought using the land certificates.",
    link: EMERALD_CITY_PRODUCTS.LOC,
  },
  {
    title: "Golden Key",
    desc: "Golden Keys are IRC-31 tokens that can be used with any two GangstaBet characters to mint Gen0 Civilians. The level & type of Gangstabet NFTs, while minting, will determine the level of Civilians that will be brought to the Emerald City. Gen0 Civilians being the first...",
    link: EMERALD_CITY_PRODUCTS.GOLDENKEY,
  },
  {
    title: "Civilians",
    desc: "The residents of The Emerald Ciity, Civillians can be brought into a city using Golden Key tokens and a pair of GangstaBet NFTs. They will have their own class with their own duties in the city. They will have their own journeys withing the city which will yeild them great rewards. Starting with Gen0 civillians.....",
    link: EMERALD_CITY_PRODUCTS.CIVILIANS,
  },

  {
    title: "FOREX",
    desc: "Forex will allow users to receive Polygon Gangstabet NFTs by locking their CROWN tokens for one year. 50% will be returned back to the user in one year, 10% will go to the Bank, 20% to the Development and Marketing Fund, and 20% will be burnt.",
    link: EMERALD_CITY_PRODUCTS.FOREX,
  },
  {
    title: "BRIBE TOKEN",
    desc: "Bribe is a token (IRC-31) that can be used with CROWN to mint a Land Certificate. The Bribe token will guarantee that the land certificate being minted will belong to a specific zone. These will be rewarded via various community events bonding the community and also providing a valuable utility in the ecosystem. There are different bribe tokens each for different types of lands.",
    link: EMERALD_CITY_PRODUCTS.BRIBE,
  },
];
const Product = () => {
  return (
    <div className="product-collection-wrapper">
      <h3 className="product-collection-wrapper-heading adjust-heading-3">
        {" "}
        More about Emerald City
      </h3>
      <div className="product-collection">
        {DATA.map((item, index) => {
          return (
            <ProductCard title={item.title} desc={item.desc} link={item.link} />
          );
        })}
      </div>
    </div>
  );
};

export default Product;
